<template>
  <div>
    <el-form :model="value" ref="formRef" :rules="formRules" label-width="95px">
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="所属车场:" prop="spaceId">
            <el-select v-model="value.spaceId" style="width: 100%" placeholder="请选择" disabled>
              <el-option
                v-for="item in spaceList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="车辆身份" prop="carManageType">
            <el-select
              disabled
              v-model="value.carManageType"
              style="width: 100%"
              placeholder="请选择车辆身份"
              @change="carManageTypeChange"
            >
              <el-option
                v-for="item in carManageTypeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="车牌号:" prop="plateNumber">
            <el-input
              clearable
              disabled
              v-model="value.plateNumber"
              placeholder="请输入车牌号"
              @blur="plateNumberBlur"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="车型大小:" prop="bigOrSmallCar">
            <el-select
              disabled
              v-model="value.bigOrSmallCar"
              style="width: 100%"
              placeholder="请选择车型大小"
              @change="bigOrSmallCarChange"
            >
              <el-option
                v-for="item in bigOrSmallCarList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="value.carManageType == 1 || value.carManageType == 2">
          <el-form-item label="主/副车" prop="isMainCar">
            <el-select
              disabled
              v-model="value.isMainCar"
              style="width: 100%"
              placeholder="请选择主/副车"
              @change="isMainCarChange"
            >
              <el-option
                v-for="item in carCategoryList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col
          :span="8"
          v-if="
            (value.carManageType == 2) &&
            value.isMainCar == 1
          "
        >
          <el-form-item label="车位编号" prop="parkingSpaceNames">
            <el-input clearable readonly :disabled="edit" v-model="value.parkingSpaceNames">
              <el-button @click="clearCarCode" slot="prepend" type="primary">清空</el-button>
              <el-button @click="selectCarCode" slot="append" type="primary">选择</el-button>
            </el-input>
          </el-form-item>
        </el-col>

        <el-col
          :span="8"
          v-if="(value.carManageType == 2 || value.carManageType == 1) && value.isMainCar == 0"
        >
          <el-form-item label="关联主车" prop="mainPlateNumber">
            <el-input readonly :disabled="edit" v-model="value.mainPlateNumber">
              <el-button @click="selectCarOwner" slot="append" type="primary">选择</el-button>
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="车主:" prop="personName">
            <el-input
              clearable
              v-model="value.personName"
              placeholder="请输入车主"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="车主电话:" prop="personPhone">
            <el-input
              clearable
              v-model="value.personPhone"
              placeholder="请输入客户手机"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            label="楼栋/单元"
            prop="buildingId"
            :rules="[{ required: false, message: '请选择楼栋/单元', trigger: 'blur' }]"
          >
            <el-select
              :disabled="edit"
              @change="buildingIdChange"
              v-model="value.buildingId"
              style="width: 100%"
            >
              <el-option
                style="padding-left: 10px"
                v-for="item in buildingList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="房间名称"
            prop="roomId"
            :rules="[{ required: false, message: '请选择房间名称', trigger: 'blur' }]"
          >
            <el-select
              :disabled="edit"
              @change="roomIdChange"
              v-model="value.roomId"
              style="width: 100%"
            >
              <el-option
                style="padding-left: 10px"
                v-for="item in roomList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8" v-if="value.carManageType == 1">
          <el-form-item label="收费套餐:" prop="feeRuleId">
            <el-select
              :disabled="value.isMainCar == 0"
              v-model="value.feeRuleId"
              style="width: 100%"
              placeholder="请选择收费套餐"
              @change="feeRuleIdChange"
            >
              <el-option
                v-for="item in ruleList"
                :key="item.id"
                :label="item.setmealName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="value.carManageType == 1">
          <el-form-item label="租赁起期:" prop="effectTime">
            <el-date-picker
              :disabled="value.isMainCar == 0"
              v-model="value.effectTime"
              style="width: 100%"
              value-format="yyyy-MM-dd 00:00:00"
              align="right"
              type="date"
              placeholder="选择租赁起期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="8" v-if="value.carManageType == 1">
          <el-form-item label="租赁止期:" prop="expiredTime">
            <el-date-picker
              :disabled="value.isMainCar == 0"
              v-model="value.expiredTime"
              style="width: 100%"
              value-format="yyyy-MM-dd 23:59:59"
              align="right"
              type="date"
              placeholder="选择租赁止期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="value.carManageType == 1">
          <el-form-item label="优惠方案:" prop="discountRuleId">
            <el-select
            clearable
              :disabled="value.isMainCar == 0"
              v-model="value.discountRuleId"
              style="width: 100%"
              placeholder="请选择优惠方案"
            >
              <el-option
                v-for="item in discountRuleList"
                :key="item.id"
                :label="item.discountName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="value.carManageType == 1">
          <el-form-item label="车辆状态:" prop="status">
            <el-select
              v-model="value.carStatus"
              style="width: 100%"
              placeholder="请选择月卡车状态"
            >
              <el-option
                v-for="item in statusList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="授权区域:" prop="regions">
            <avue-input-tree
              style="width: 100%"
              :props="treeRegionProps"
              v-model="value.regions"
              placeholder="请选择区域"
              type="tree"
              multiple
              checkStrictly
              :dic="regionList"
              :disabled="value.isMainCar == 0"
            ></avue-input-tree>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注:" prop="description">
            <el-input
              clearable
              v-model="value.description"
              type="textarea"
              :rows="4"
              placeholder="请输入备注"
              show-word-limit
              maxlength="200"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div style="float: right">
            <el-button
              type="primary"
              icon="el-icon-circle-plus-outline"
              @click="saveRecord"
              size="small"
              >修改
            </el-button>
            <el-button icon="el-icon-circle-close" @click="cancelRecord" size="small">
              取消
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>

    <hr-dialog
      width="80%"
      :visible.sync="showCarCodeFlag"
      :title="'车辆编码'"
      :handleClose="handleCloseCarCodeFlag"
    >
      <template slot="body">
        <div>
          <parkvihicleCarCode
            v-if="showCarCodeFlag"
            :spaceId="value.spaceId"
            :carManageType="value.carManageType"
            :carId="value.id"
            @getCarCode="getCarCode"
          >
          </parkvihicleCarCode>
        </div>
      </template>
      <template slot="footer">
        <div class="btnArea" style="text-align: right; margin-right: 24px">
          <el-button
            size="small"
            type="primary"
            icon="el-icon-circle-plus-outline"
            @click="selectConfirm"
            style="margin-right: 20px"
            >确定</el-button
          >
          <el-button @click="closeCarCodeRecord" size="small" icon="el-icon-circle-close"
            >取消</el-button
          >
        </div>
      </template>
    </hr-dialog>

    <hr-dialog
      width="80%"
      :visible.sync="showCarOwnerFlag"
      :title="value.carManageType == 2 ? '关联固停车车主' : '关联主车'"
      :handleClose="handleCloseCarOwnerFlag"
    >
      <template slot="body">
        <div>
          <parkvihicleCarOwner
            v-if="showCarOwnerFlag"
            :spaceId="value.spaceId"
            :carManageType="value.carManageType"
            :carId="value.id"
            @getCarOwner="getCarOwner"
          >
          </parkvihicleCarOwner>
        </div>
      </template>
      <template slot="footer">
        <div class="btnArea" style="text-align: right; margin-right: 24px">
          <!-- v-if="isEdit" -->
          <el-button
            size="small"
            type="primary"
            icon="el-icon-circle-plus-outline"
            @click="selectCarOwnerConfirm"
            style="margin-right: 20px"
            >确定</el-button
          >
          <!-- v-if="isEdit" -->
          <el-button @click="closeCarOwnerRecord" size="small" icon="el-icon-circle-close"
            >取消</el-button
          >
        </div>
      </template>
    </hr-dialog>
  </div>
</template>
<script>
import _ from 'lodash';
import {
  update,
  addRegister,
  getBuildingList,
  getRoomList,
  getCarRuleList,
  editPlus,
  getCarRuleDiscountList,
  calculateMonthCarFeeInFo,
  getCarRuleDiscountListNew,
  getManageDetail,
} from './parkvehicle';
import { nodeTreeByParentId } from '@/api/v4ward/carv2/carmonth';
import { editPlusCarMonth } from '@/api/v4ward/carv2/carcharge';
import { getSpaceList, isCarMonth } from '@/api/v4ward/carv2/carmonthquickRegistration';
import { getDictionary } from '@/api/common.js';
import {
  monthChargeRuleListV2,
  editPlusGetdiscountRuleId,
} from '@/api/v4ward/carv2/carmonthchargerule';
import parkvihicleCarCode from '@/views/v4ward/park/vehiclev3/parkvehicle-carcode';
import parkvihicleCarOwner from '@/views/v4ward/park/vehiclev3/parkvehicle-carowner';
export default {
  components: {
    parkvihicleCarCode,
    parkvihicleCarOwner,
  },
  props: ['value'],
  data() {
    return {cycleNumList:[],
      roomList: [],
      buildingList: [],
      showCarOwnerFlag: false,
      showCarCodeFlag: false,
      regionList: [],
      treeRegionProps: {
        labelText: '标题',
        label: 'title',
        value: 'id',
        children: 'children',
      },
      carManageTypeList: [],
      bigOrSmallCarList: [], //车辆类型
      carCategoryList: [], //车辆类别
      ruleList: [], //收费套餐
      discountRuleList: [], //优惠规则
      statusList: [], //月卡车状态
      spaceList: [], //车场
      formRules: {
        spaceId: [{ required: true, message: '车场名称不能为空', trigger: 'blur' }],
        plateNumber: [{ required: true, message: '车牌号不能为空', trigger: 'blur' }],
        regions: [{ required: true, message: '区域不能为空', trigger: 'blur' }],
        isMainCar: [{ required: true, message: '车辆类别不能为空', trigger: 'blur' }],
        bigOrSmallCar: [{ required: true, message: '车辆类型不能为空', trigger: 'blur' }],
        feeRuleId: [{ required: true, message: '收费套餐不能为空', trigger: 'blur' }],
        effectTime: [{ required: true, message: '租赁起期不能为空', trigger: 'blur' }],
        expiredTime: [{ required: true, message: '租赁止期不能为空', trigger: 'blur' }],
        personName: [{ required: true, message: '客户姓名不能为空', trigger: 'blur' }],
        status: [{ required: true, message: '月卡车状态不能为空', trigger: 'blur' }],
        mainPlateNumber: [{ required: true, message: '关联主车不能为空', trigger: 'blur' }],
        parkingSpaceNames: [{ required: true, message: '车位编号不能为空', trigger: 'change' }],
      },
    };
  },
  created() {
    this.value.bigOrSmallCar += '';
    this.value.isMainCar += '';
    this.value.feeRuleId += '';
    this.value.carStatus += '';
    this.initData();
  },
  methods: {
    //获取续租时长
    getCycleNumList() {
      getDictionary('park_fee_cycle').then((res) => {
        this.cycleNumList = res.data;
      });
    },
    getBuildingListHandler() {
      getBuildingList({ spaceId: this.value.spaceId }).then((res) => {
        this.buildingList = res.data;
      });
    },
    roomIdChange(val){
      let this_ = this;
      this.roomList.forEach(ele=>{
        if(val===ele.value){
          this_.value.roomName = ele.label;
        }
      })
    },
    buildingIdChange(val,flag) {
      let this_ = this;
      if(!flag){
        this.value.roomId = '';
        this.value = this._.cloneDeep(this_.value);
      }
      getRoomList({ buildingId: this.value.buildingId }).then((res) => {
        this.roomList = res.data;
      });
    },
    getCarOwner(val) {
      console.log(val);
      this.value.mainCarId = val[0];
      this.value.mainPlateNumber = val[1];
      console.log(this.value.mainCarId.split(',').length);
      if (!this.value.mainCarId) {
        return;
      }
      if (this.value.mainCarId && this.value.mainCarId.split(',').length > 1) {
        this.value.mainCarId = '';
        this.value.mainPlateNumber = '';
        this.$message.warning('请选择一条数据');
        return;
      }
      this.value = this._.cloneDeep(this.value);
      getManageDetail({ id: val[0] }).then((res) => {
        this.value.feeRuleId = res.data.feeRuleId;
        this.value.cycleNum = res.data.cycleNum;
        this.value.discountRuleId = res.data.discountRuleId;
        this.value.shouldAmount = res.data.shouldAmount;
        this.value.payAmount = res.data.payAmount;
        this.value.discountAmount = res.data.discountAmount;
        // this.value.regionIds = this.value.regions.join(',');
        this.value.regions = res.data.regionIds.split(',');
        if (this.value.carManageType == 1) {
          this.value.effectTime = res.data.effectTime;
          this.value.expiredTime = res.data.expiredTime;
          getCarRuleList({
            spaceId: this.value.spaceId,
            packageType: this.value.carManageType,
            bigOrSmallCar: this.value.bigOrSmallCar,
          }).then((res) => {
            this.ruleList = res.data;
          });

          getCarRuleDiscountListNew({
            spaceId: this.value.spaceId,
            payPeriods: this.value.cycleNum,
            carFeeRuleId: this.value.feeRuleId,
          }).then((res) => {
            this.discountRuleList = res.data;
          });
        }
        console.log('getManageDetail=============>', res.data);
      });
    },
    selectCarOwner() {
      this.showCarOwnerFlag = true;
    },
    selectCarOwnerConfirm() {
      this.showCarOwnerFlag = false;
    },
    closeCarOwnerRecord() {
      this.showCarOwnerFlag = false;
    },
    handleCloseCarOwnerFlag() {
      this.closeCarOwnerRecord();
    },

    getCarCode(val) {
      console.log(val);
      if (this.value.carManageType == 2) {
        this.value.parkingSpaceIds = val[0];
        this.value.parkingSpaceNames = val[1];
      }
      if (this.value.carManageType == 1) {
        this.value.parkingSpaceIds_ = val[0];
        this.value.parkingSpaceNames_ = val[1];
      }
      this.value = this._.cloneDeep(this.value);
      console.log(this.value.parkingSpaceNames);
      setTimeout(() => {
        // this.$refs.parkingSpaceNamesInput.blur();
        console.log(this.$refs.parkingSpaceNamesInput);
      });
    },
    selectConfirm() {
      this.showCarCodeFlag = false;
    },
    closeCarCodeRecord() {
      this.value.regionNames = '';
      this.value.parkingSpaceIds = '';
      this.showCarCodeFlag = false;
    },
    handleCloseCarCodeFlag() {
      this.closeCarCodeRecord();
    },
    selectCarCode() {
      this.showCarCodeFlag = true;
    },
clearCarCode(){
  this.value.parkingSpaceIds = '';
  this.value.parkingSpaceNames = '';
  this.value.parkingSpaceIds_ = '';
  this.value.parkingSpaceNames_ = '';
  this.value = this._.cloneDeep(this.value);
},
    isMainCarChange() {
      this.value.feeRuleId = '';
      this.value.discountRuleId = '';
      if (this.value.bigOrSmallCar && this.value.isMainCar) {
        this.getCarRuleListHandler();
      }
    },
    bigOrSmallCarChange() {
      this.value.feeRuleId = '';
      this.value.discountRuleId = '';
      if (this.value.bigOrSmallCar && this.value.isMainCar) {
        this.getCarRuleListHandler();
      }
    },
    plateNumberBlur() {
      isCarMonth({
        spaceId: this.value.spaceId,
        plateNumber: this.value.plateNumber,
      });
    },
    initData() {
      this.getSpaceList();
      this.getRegion(this.value.spaceId);
      this.getCarCategory();
      this.getbigOrSmallCar();
      if (this.value.carManageType == 1) {
        this.getCarRuleListHandler();
        this.getDiscountList();
      }
      this.getCarMonthStatus();
      // this.getCarRule();

      this.getBuildingListHandler();
      this.buildingIdChange('',1);
      this.getCarManageTypeList();
      this.value.regions = this.value.regionIds.split(',');
      if(this.value.carManageType == 1){
        this.value.parkingSpaceNames_ = this.value.parkingSpaceNames
        this.value.parkingSpaceIds_ = this.value.parkingSpaceIds
      }
    },
    getSpaceList() {
      getSpaceList().then((res) => {
        this.spaceList = res.data;
      });
    },
    //获取区域
    getRegion(id) {
      nodeTreeByParentId(id).then((res) => {
        this.regionList = res.data;
      });
    },
    //获取车辆类别(车主类别)
    getCarCategory() {
      getDictionary('car_category_v2').then((res) => {
        // this.carCategoryList = res.data;
        this.carCategoryList = [
          {
            dictValue: '副车',
            dictKey: '0',
          },
          {
            dictValue: '主车',
            dictKey: '1',
          },
        ];
      });
    },
    //车辆类型
    getbigOrSmallCar() {
      getDictionary('car_type_v2').then((res) => {
        this.bigOrSmallCarList = res.data;
      });
    },
    //获取收费套餐
    // getCarRule() {
    //   monthChargeRuleListV2(
    //     Object.assign({
    //       spaceId: this.value.spaceId,
    //       bigOrSmallCar: this.value.bigOrSmallCar,
    //       carCategory: this.value.isMainCar,
    //     })
    //   ).then(({ data }) => {
    //     this.ruleList = data;
    //   });
    // },
    feeRuleIdChange(){
      this.value.discountRuleId = '';
      this.value = this._.cloneDeep(this.value);
      this.getDiscountList();
    },
    cycleNumChange(){
      this.value.discountRuleId = '';
      this.value = this._.cloneDeep(this.value);
      this.getDiscountList();
    },
    getCarRuleListHandler() {
      getCarRuleList({ spaceId: this.value.spaceId, packageType: this.value.carManageType,
            bigOrSmallCar: this.value.bigOrSmallCar, }).then(
        (res) => {
          // this.carRuleList = res.data;
          this.ruleList = res.data;
          this.carRuleDisabled = false;
        }
      );
    },
    //获取优惠规则
    getDiscountList() {
      getCarRuleDiscountList({
        spaceId: this.value.spaceId,
        // payPeriods: this.value.cycleNum,
        carFeeRuleId: this.value.feeRuleId,
      }).then((res) => {
        this.discountRuleList = res.data;
      });
    },
    getCarMonthStatus() {
      getDictionary('car_month_status').then((res) => {
        this.statusList = res.data;
      });
    },
    getCarManageTypeList() {
      getDictionary('car_manage_type').then((res) => {
        this.carManageTypeList = res.data;
      });
    },
    saveRecord() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          console.log('this.value.regions============>', this.value.regions);
          this.value.regionIds = this.value.regions.join(',');
          this.value.carCategory = this.value.isMainCar;
          if(this.value.parkingSpaceNames_){
            this.value.parkingSpaceNames = this.value.parkingSpaceNames_
            this.value.parkingSpaceIds = this.value.parkingSpaceIds_
          }
          editPlus(this.value).then((res) => {
            this.$message.success('修改成功');
            this.$emit('success');
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    cancelRecord() {
      console.log('触发关闭');
      this.$confirm('是否关闭继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$emit('cancel');
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
  },
};
</script>
<style scoped>
::v-deep .el-col-8 {
  height: 54px;
}
</style>
